// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PExclamationOutlinedSvg from "@fishx/icons-svg/es/asn/PExclamationOutlined";
import FishxIcon from '../components/FishxIcon';

var PExclamationOutlined = function PExclamationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PExclamationOutlinedSvg
  }));
};

PExclamationOutlined.displayName = 'PExclamationOutlined';
export default React.forwardRef(PExclamationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PExclamationOutlined.js
// module id = 3368
// module chunks = 0